import script from "./i-price-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./i-price-list.vue?vue&type=script&lang=tsx&setup=true"

import "./i-price-list.vue?vue&type=style&index=0&id=24c8c187&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c8c187"]])

export default __exports__